/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FollowNotificationActionData
 */
export interface FollowNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FollowNotificationActionData
     */
    followerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FollowNotificationActionData
     */
    followeeUserId: string;
}

/**
 * Check if a given object implements the FollowNotificationActionData interface.
 */
export function instanceOfFollowNotificationActionData(value: object): value is FollowNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "followerUserId" in value && value["followerUserId"] !== undefined;
    isInstance = isInstance && "followeeUserId" in value && value["followeeUserId"] !== undefined;

    return isInstance;
}

export function FollowNotificationActionDataFromJSON(json: any): FollowNotificationActionData {
    return FollowNotificationActionDataFromJSONTyped(json, false);
}

export function FollowNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'followerUserId': json['follower_user_id'],
        'followeeUserId': json['followee_user_id'],
    };
}

export function FollowNotificationActionDataToJSON(value?: FollowNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'follower_user_id': value.followerUserId,
        'followee_user_id': value.followeeUserId,
    };
}

